import React from "react";
import { Button } from "reactstrap";

const CalcBtn = (props) => {
  return (
    <div>
      <Button
        className={
          props.medicalCalculations ? "calculatorActiveBtn" : "calculator-btn"
        }
        onClick={props.calculateAmount}
      >
        {props.title}
      </Button>
    </div>
  );
};

export default CalcBtn;
